/*
 * Copyright (C) 2024 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { Component, inject, Input, OnInit } from '@angular/core';
import { ApiRootLinkRel, ApiRootResource } from '@common/api-root-shared';
import { AuthenticationService } from '@common/authentication';
import { GetUrlPipe, HasLinkPipe, StateResource } from '@common/tech-shared';
import { DropdownMenuComponent, DropdownMenuLinkItemComponent, FileIconComponent } from '@ods/system';
import { UserLogoutButtonComponent } from '../user-logout-button/user-logout-button.component';
import { UserMenuButtonComponent } from '../user-menu-button/user-menu-button.component';

@Component({
  selector: 'administration-user-profile-button-container',
  templateUrl: './user-profile-button-container.component.html',
  imports: [
    DropdownMenuComponent,
    HasLinkPipe,
    GetUrlPipe,
    DropdownMenuLinkItemComponent,
    FileIconComponent,
    UserLogoutButtonComponent,
    UserMenuButtonComponent,
  ],
})
export class UserProfileButtonContainerComponent implements OnInit {
  @Input() apiRootStateResource: StateResource<ApiRootResource>;

  public currentUserInitials: string;
  public currentUserName: string;

  public readonly authenticationService: AuthenticationService = inject(AuthenticationService);

  public readonly ApiRootLinkRel = ApiRootLinkRel;

  ngOnInit(): void {
    this.currentUserInitials = this.authenticationService.getCurrentUserInitials();
    this.currentUserName = this.authenticationService.getCurrentUserName();
  }
}
